// Pure helpers for the Manage Access tree (kept apart from the page so they can be tested without rendering).
export const TREE_ACTIONS = ["VIEW", "CREATE", "EDIT", "DELETE", "APPROVE", "POST"];

export function flatten(nodes, depth = 0, parentKey = null, out = []) {
  for (const n of nodes) {
    out.push({ node: n, depth, parentKey });
    flatten(n.children || [], depth + 1, n.key, out);
  }
  return out;
}

export function descendants(node, out = []) {
  for (const c of node.children || []) { out.push(c); descendants(c, out); }
  return out;
}

export function draftFrom(tree) {
  const draft = {};
  for (const { node } of flatten(tree)) draft[node.key] = { ...node.stored };
  return draft;
}

/** Modules whose four switches differ from what is saved. */
export function changedModules(tree, draft) {
  return flatten(tree).filter(({ node }) => TREE_ACTIONS.some((a) => !!draft[node.key]?.[a] !== !!node.stored[a])).map(({ node }) => node.key);
}

/** A feature is closed when any ancestor has View switched off in the draft. */
export function closedByParent(node, draft, byKey) {
  let p = node.parent ? byKey[node.parent] : null;
  while (p) {
    if (!draft[p.key]?.VIEW) return true;
    p = p.parent ? byKey[p.parent] : null;
  }
  return false;
}

/** Search keeps a row when it, or something under it, matches; returns the keys to show and the keys to open. */
export function searchTree(tree, query) {
  const q = query.trim().toLowerCase();
  if (!q) return null;
  const show = new Set(), open = new Set();
  const hit = (n) => `${n.label} ${n.covers || ""} ${n.key}`.toLowerCase().includes(q);
  const walk = (n, trail) => {
    let any = hit(n);
    for (const c of n.children || []) if (walk(c, [...trail, n.key])) any = true;
    if (any) { show.add(n.key); trail.forEach((k) => open.add(k)); }
    return any;
  };
  tree.forEach((n) => walk(n, []));
  return { show, open };
}

/** How many of the features below a row have `action` on: "3 of 6". */
export function childSummary(node, draft, action) {
  const kids = descendants(node);
  if (!kids.length) return null;
  return { on: kids.filter((c) => draft[c.key]?.[action]).length, of: kids.length };
}
